module.exports = __webpack_public_path__ + "img/insight-dark.a75d2d4d.svg";